module.exports = __webpack_public_path__ + "static/img/ThangLong.49405bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ThangLong.png
// module id = Jx4D
// module chunks = 1